// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TpSsB","badges":"styles_badges__DGoEn"};